import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType;
};
